import axios from 'axios';

import appVariablesUrl from './apiUrl';

const getAppVariables = () => axios.get(appVariablesUrl);

export default getAppVariables;
